module.exports = __webpack_public_path__ + "img/credit-card-refinancing-icon.8633417c.svg";